import { types } from 'mobx-state-tree';
import { createThunk, ListModel, model } from 'mst-collection';

import { Api, schemas } from '@api';
import { TagModel } from './TagModel';

export class RecommendedTagsList extends ListModel(
  types.reference(TagModel),
  {
    schema: schemas.TagsListSchema,
  },
) {
  fetch = createThunk(() => {
    return async function fetch(this: RecommendedTagsList) {
      const res = await Api.Hub.getTags({ recommendedTags: true });

      this.set(res.data.tags);
    };
  });
  get appliedTagNames() {
    const tags = this.asArray.filter((i) => i.isSelected);

    if (tags.length === 0) {
      return null;
    }
    return tags.map((i) => i.name).flat();
  }

  get appliedTagIds() {
    return this.asArray
      .filter((i) => i.isSelected)
      .map((i) => i.id)
      .flat();
  }

  clearTagsSelection() {
    this.asArray.forEach((i) => i.clearSelection());
  }
}

export const RecommendedTagsListModel = model(RecommendedTagsList);
